import { __decorate } from "tslib";
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
/**
 * @param Base The base class.
 * @returns Dropdown item component shell.
 */
export class DropdownItem extends CipublicElement {
    constructor() {
        super(...arguments);
        /**
         * Item initially selected.
         */
        this.selected = false;
    }
}
__decorate([
    property({ reflect: true })
], DropdownItem.prototype, "value", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], DropdownItem.prototype, "selected", void 0);
//# sourceMappingURL=dropdown-item.js.map